module.exports = __webpack_public_path__ + "static/img/cn.2f61d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/cn.png
// module id = ASDU
// module chunks = 18